<template>
    <div>
        <app-erros-box :erros="erros" v-if="erros.length > 0"></app-erros-box>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label class="required">Descrição</label>
                    <b-form-textarea
                        v-model="descricao"
                        :rows="2"
                        maxlength="250"
                        @input="$v.descricao.$touch()"
                        :state="$v.descricao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A descrição é obrigatória
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.valorTotal.$error ? false : null"
                    invalid-feedback="Valor Total é obrigatório"
                >
                    <label class="required">Valor Total</label>
                    <money
                        v-model="valorTotal"
                        v-bind="$moneyConfig"
                        class="form-control text-right"
                        @input.native="$v.valorTotal.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.valorInvestido.$error ? false : null"
                    invalid-feedback="Informe um valor válido"
                >
                    <label>Valor Investido</label>
                    <money
                        v-model="valorInvestido"
                        v-bind="$moneyConfig"
                        class="form-control text-right"
                        @input.native="$v.valorInvestido.$touch()"
                    ></money>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12" md="6">
                <b-form-group
                    :state="$v.prazoFinal.$error ? false : null"
                    invalid-feedback="Prazo Final é obrigatório"
                >
                    <label class="required">Prazo Final</label>
                    <date-picker
                        v-model="prazoFinal"
                        :config="$datePickerOptions"
                        v-mask="'##/##/####'"
                        @input.native="$v.prazoFinal.$touch()"
                    ></date-picker>
                </b-form-group>
            </b-col>
            <b-col sm="12" md="6">
                <b-form-group>
                    <label class="required">Status</label>
                    <b-form-select
                        :options="statusList"
                        v-model="status"
                        text-field="nameStatus"
                        value-field="idStatus"
                        @input="$v.status.$touch()"
                    ></b-form-select>
                </b-form-group>
            </b-col>
        </b-row>
        <b-row>
            <b-col sm="12">
                <b-form-group>
                    <label :class="{ required: operacaoAtualizacao }"
                        >Observação</label
                    >
                    <b-form-textarea
                        v-model="observacao"
                        :rows="2"
                        maxlength="250"
                        @input="$v.observacao.$touch()"
                        :state="$v.observacao.$error ? false : null"
                    ></b-form-textarea>
                    <b-form-invalid-feedback>
                        A observação é obrigatória para atualização
                    </b-form-invalid-feedback>
                </b-form-group>
            </b-col>
        </b-row>
        <div class="modal-footer">
            <b-button variant="secondary" @click.stop="fecharModal()">
                Cancelar
            </b-button>
            <b-button
                variant="primary"
                @click.stop="confirmarSalvar()"
                class="ml-1"
                :disabled="desabilitarBtnSalvar"
            >
                Salvar
            </b-button>
        </div>
    </div>
</template>

<script>
import { required, minValue } from 'vuelidate/lib/validators'
import ParcelamentoServicos from './ParcelamentoServicos'

export default {
    props: {
        investimento: {
            type: Object,
            default: () => ({})
        },

        tipoOperacao: {
            type: String,
            default: () => ''
        },

        showModal: {
            type: Boolean,
            default: () => false
        },

        parcelamento: {
            type: Object,
            default: () => {}
        }
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
            descricao: '',
            valorInvestido: 0,
            valorTotal: 0,
            prazoFinal: new Date(),
            status: 0,
            observacao: null,
            statusList: [
                { idStatus: 0, nameStatus: 'Pendente' },
                { idStatus: 1, nameStatus: 'Concluído' }
            ]
        }
    },

    methods: {
        fecharModal() {
            this.mostrarModal = false
            this.resetFormulario()
            this.$emit('modalFechado')
        },

        resetFormulario() {
            ;(this.erros = []),
                (this.descricao = ''),
                (this.valorInvestido = 0),
                (this.valorTotal = 0),
                (this.status = 0),
                (this.prazoFinal = new Date()),
                this.$nextTick(() => {
                    this.$v.$reset()
                })
        },

        preencherForm() {
            if (this.operacaoAtualizacao) {
                this.obterParcelamento()
            }
        },

        obterParcelamento() {
            let parcelamentoDto = {
                idContrato: this.investimento.idContrato,
                idInvestimento:
                    this.investimento.idInvestimentoPrevistoContrato,
                idParcelaInvestimentoPrevistoContrato:
                    this.parcelamento.idParcelaInvestimentoPrevistoContrato
            }

            this.$store.dispatch('addRequest')
            ParcelamentoServicos.obterParcelamento(parcelamentoDto).then(
                (response) => {
                    if (response) {
                        if (response.success) {
                            this.descricao = response.data.descricao
                            this.status = response.data.status
                            this.valorInvestido = response.data.valorInvestido
                            this.valorTotal = response.data.valorTotal
                            this.prazoFinal = this.$moment(
                                response.data.prazoFinal
                            ).format('DD/MM/YYYY')
                            this.observacao = response.data.observacao
                        } else {
                            this.$toast.error(
                                'Erro ao obter o Parcelamento',
                                'ERROR',
                                this.$toastConfig.error
                            )
                        }
                    }
                    this.$store.dispatch('removeRequest')
                }
            )
        },

        confirmarSalvar() {
            let msg
            if (this.tipoOperacao == 'i') {
                msg = 'Confirma a inserção do Parcelamento?'
            } else {
                msg = 'Confirma a atualização do Parcelamento?'
            }

            this.$swal({
                title: 'Parcelamento',
                html: msg,
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Sim',
                cancelButtonText: 'Não'
            }).then((result) => {
                if (result.value) {
                    this.salvar()
                }
            })
        },

        salvar() {
            this.$store.dispatch('addRequest')
            let parcelamentoDto = {
                descricao: this.descricao,
                prazoFinal: this.prazoFinal
                    ? this.$moment(this.prazoFinal, 'DD/MM/YYYY').toISOString()
                    : '',
                valorTotal: this.valorTotal,
                valorInvestido: this.valorInvestido,
                status: this.status,
                observacao: this.observacao
            }

            let promisse
            if (this.tipoOperacao == 'i') {
                promisse = ParcelamentoServicos.inserir(parcelamentoDto, this.investimento.idContrato, this.investimento.idInvestimentoPrevistoContrato)
            } else {
                parcelamentoDto = { 
                    ...parcelamentoDto,
                    idContrato: this.investimento.idContrato,
                    idInvestimento: this.investimento.idInvestimentoPrevistoContrato,
                    idParcelaInvestimentoPrevistoContrato: this.parcelamento.idParcelaInvestimentoPrevistoContrato,
                }
                promisse = ParcelamentoServicos.atualizar(parcelamentoDto, this.investimento.idContrato, this.investimento.idInvestimentoPrevistoContrato, this.parcelamento.idParcelaInvestimentoPrevistoContrato)
            }

            promisse.then(response => {
                if (response) {
                    if (response.success) {
                        this.registroSalvoComSucesso()
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
        },

        registroSalvoComSucesso() {
            this.$toast.success(
                'Operação realizada com sucesso!',
                'OK',
                this.$toastConfig.success
            )
            this.$emit('obterParcelamentosAtualizados')
            this.fecharModal()
        }
    },

    created() {
        this.preencherForm()
    },

    computed: {
        desabilitarBtnSalvar() {
            return this.$v.$invalid
        },

        operacaoAtualizacao() {
            return this.tipoOperacao == 'a'
        }
    },

    watch: {
        showModal() {
            this.mostrarModal = this.showModal
        }
    },

    validations: {
        descricao: {
            required
        },

        prazoFinal: {
            required
        },

        valorTotal: {
            required,
            minValue: minValue(0.01)
        },

        valorInvestido: {
            minValue: minValue(0.0)
        },

        status: {
            required
        },

        observacao: {
            obrigatorio() {
                if (this.operacaoAtualizacao) {
                    return this.observacao != null && this.observacao != ''
                }
                return true
            }
        }
    }
}
</script>
<style scoped>
.modal-footer {
    justify-content: flex-end;
    padding: 1rem 0 0 0;
    margin: 0.5rem 0 0 0;
    border-top: 1px solid #c8ced3;
}
</style>
